<template>
  <div>
    <CRow>
      <CCol col="12" xl="12">
        <CCard>
          <CCardHeader>
            <CDropdown toggler-text="..." class="ml-1 float-right" color="secondary" :caret="false">
              <CDropdownItem @click="cancelChanges">Cancel changes</CDropdownItem>
              <CDropdownDivider />
              <CDropdownItem :disabled="isNew" @click="deleteLink">Delete Link</CDropdownItem>
            </CDropdown>

            <CButton :color="saveButton.color" :disabled="saveDisabled" @click="saveData" class="float-right">
              <CIcon :name="saveButton.icon" size="sm" class="mr-1" />{{ saveButton.text }}
            </CButton>
            <h3>
              {{ link.title || 'New Link' }}
            </h3>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="3">
                <CInput label="Title" placeholder="Enter a label for this screen" v-model="link.title" />
              </CCol>
              <CCol sm="2">
                <CSelect
                  label="Link type"
                  :value.sync="link.entity_type"
                  :options="settings.link_entity_types"
                  placeholder="Please select an entity type"
                />
              </CCol>
              <CCol sm="2">
                <CSelect
                  label="Icon"
                  :value.sync="link.asset_name"
                  :options="settings.app_assets"
                  placeholder="Select an icon asset name"
                />
              </CCol>
              <CCol sm="5">
                <CSelect
                    v-if="link.entity_type === 'playlist'"
                    :value.sync="link.entity_id"
                    label="Playlist"
                    :options="settings.playlist_lookups"
                    placeholder="Select a playlist"
                />
                <EntityDropdown
                    v-else
                    @on-item-selected="link.entity_id = $event.id"
                    :entity-type="link.entity_type"
                    :selected-id="link.entity_id"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea
                  label="Help Text"
                  placeholder="Add a help text or description here. This will only appear for links that are used in Tabs."
                  v-model="link.help_txt"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CSelect
                    :value.sync="link.widget.type"
                    label="Optional Widget type"
                    :options="widgetTypes"
                    placeholder="Select a widget type"
                    description="Selecting a widget will allow you to turn this link into a specially styled item. Leave blank for a regular link."
                />
              </CCol>
            </CRow>
            <CRow v-if="link.widget.type == 'coming_soon' && link.entity_type !='episode'">
              <CCol sm="12">
                <CAlert color="danger">This widget can only be used for link type episode.</CAlert>
              </CCol>
            </CRow>
            <CRow v-if="link.widget.type == 'coming_soon' && link.entity_type =='episode'">
              <CCol sm="4">
                Widget example:<br />
                <CImg src="/static/coming_soon.png" :fluid="true"/>
              </CCol>
              <CCol sm="8">
                <CInput
                  label="Flag"
                  placeholder="Coming soon!"
                  v-model="link.widget.flag"
                />
                <CInput
                  label="Headline"
                  placeholder="Some great new podcast"
                  v-model="link.widget.headline"
                />
                <CTextarea
                  label="Description"
                  placeholder="Add some text here"
                  v-model="link.widget.description"
                />
                <CInput
                  label="Listen now txt"
                  placeholder="Listen to the trailer now"
                  v-model="link.widget.listen_now"
                />
              </CCol>
            </CRow>

            <CRow v-if="link.widget.type == 'soft_paywall'">
              <CCol sm="4">
                Widget example:<br />
                <CImg src="/static/soft_paywall.png" :fluid="true"/>
              </CCol>
              <CCol sm="8">
                <CInput
                  label="Title text"
                  placeholder="Luister onbeperkt met een NRC abonnement"
                  v-model="link.widget.title_text"
                />
                <CInput
                  label="Bold text"
                  placeholder="Nu 3 maanden gratis"
                  v-model="link.widget.title_text_bold"
                />
                <CInput
                  label="Butotn text"
                  placeholder="Ik word abonnee"
                  v-model="link.widget.button_text"
                />
                <CInput
                  label="Button URL"
                  placeholder="https://www.nrc.nl/paywall-test"
                  v-model="link.widget.button_url"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter>
            <span class="float-right"> Link ID: {{ link.id }}</span>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import EntityDropdown from '../../components/EntityDropdown'

export default {
  name: 'Link',
  components: { EntityDropdown },
  data() {
    return {
      link: {
        id: 0,
        title: '',
        entity_type: 'screen',
        entity_id: 0,
        help_txt: '',
        asset_name: '',
        widget: {
        },
      },
      isNew: false,
      saveDisabled: true,
      saveButtons: [
        { color: 'secondary', text: 'Saved', icon: 'cil-check-alt' },
        { color: 'danger', text: 'Save Link', icon: 'cil-save' },
      ],
      errorAction: '',
      settings: this.$settings,
      widgetTypes: [
        { value: '', label: 'No widget'}, 
        { value: 'coming_soon', label: 'Coming soon!'},
        { value: 'soft_paywall', label: 'Soft paywall'},
      ],
      widget: {
        type: '',
        flag: '',
        headline: '',
        description: '',
        listen_now: '',
      }
    }
  },
  mounted() {
    this.getData()
  },
  destroyed() {
    this.$store.dispatch('closeError')
  },
  watch: {
    link: {
      deep: true,
      handler(val, oldVal) {
        if (!val.widget) {
          val.widget= this.widget;
        }
        if (!oldVal.title  || !oldVal.entity_type || !oldVal.entity_id) {
          return
        }
        this.saveDisabled = false
      },
    },
  },
  computed: {
    saveButton() {
      return this.saveButtons[this.saveDisabled ? 0 : 1]
    },
  },
  methods: {
    getData() {
      if (this.$route.params.id == 0) {
        this.isNew = true
        return
      }
      this.$api
        .get(`link/${this.$route.params.id}`)
        .then(response => {
          this.link = response.data
        })
        .catch(error => this.$store.dispatch('throwError', error))
    },

    saveData() {
      let link = Object.assign({}, this.link);
      if(!link.widget.type) {
        link.widget = null
      }
      if (this.isNew) {
        delete link.id
        this.$api
          .post(`link/`, link)
          .then(result => {
            this.$router.push({ path: `${result.data.id}` })
            this.link.id = result.data.id
            this.isNew = false
            this.saveDisabled = true
          })
          .catch(error => this.$store.dispatch('throwError', error))
      } else {
        this.$api
          .put(`link/`, link)
          .then(() => {
            this.saveDisabled = true
          })
          .catch((error) => {
            this.$store.dispatch('throwError', error);
            console.log(error)
          });
      }
    },

    deleteLink() {
      if (confirm('This will delete this link. Are you sure?')) {
        this.$api
          .delete(`link/${this.link.id}`)
          .then(() => {
            this.$router.push({ path: `/links` })
          })
          .catch(error => {
            if (error.response.status === 405) {
              this.$store.dispatch('throwError', {
                hasError: error.response.data.detail.message,
                errorAction: error.response.data.detail.action,
              })
            } else {
              this.$store.dispatch('throwError', error)
            }
          })
      }
    },

    cancelChanges() {
      this.$router.push({ path: `/links` })
    },
  },
}
</script>
